import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '@/shared/ui/dialogs/ConfirmDialog';
import { useEntityDelete } from '@/shared/hooks/useEntityDelete';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiPackagesDelete } from '@/entities/packages';
import type { ApiPackagesGetItem } from '@/shared/types/api/packages';

type Props = {
  pkg: ApiPackagesGetItem | null;
  onClose: () => void;
};

export const FeaturesPackagesDeleteDialog = ({ pkg, onClose }: Props) => {
  const { t } = useTranslation();

  const remove = useEntityDelete({
    api: (id: string) => apiPackagesDelete(id),
    invalidateKeys: [queryKeys.packages.all, queryKeys.parcels.all],
    successKey: 'packages.toasts.deleted',
    onSuccess: onClose,
  });

  return (
    <ConfirmDialog
      open={Boolean(pkg)}
      title={t('packages.delete.title')}
      description={t('packages.delete.description', { name: pkg?.name ?? '' })}
      confirmLabel={t('packages.delete.confirm')}
      cancelLabel={t('common.cancel')}
      confirmVariant="danger"
      loading={remove.isPending}
      onConfirm={() => pkg && remove.mutate(pkg.id)}
      onCancel={onClose}
    />
  );
};
